import React, { useEffect, useState } from "react";
import "./trainingsSection.scss";
import { Link } from "react-router-dom";
import logo1 from "../../../assets/icon1.png";
import logo2 from "../../../assets/icon2.png";
import logo3 from "../../../assets/icon3.png";
import logo4 from "../../../assets/icon4.png";
import book from "../../../assets/book.webp";

const trainings = [
  {
    title: "Анхан, дунд шатны сургалт",
    desc: "Хөрөнгийн зах зээлийн талаар анхан шатны ойлголттой болж, хөрөнгө оруулалтын багцаа хэрхэн зөв, системтэй бүрдүүлэх талаар мэдлэгтэй болно.",
    className: "purple",
    image: logo4,
  },
  {
    title: "OCHIROO’S THEORY",
    desc: "Хөрөнгийн зах зээлийн талаар гүнзгий, системчилсэн мэдлэг эзэмшиж, техник шинжилгээ, арилжааны сэтгэл зүй, эрсдэлийн болон мөнгөний менежментийг онол-практикийн ...",
    className: "blue",
    image: logo1,
  },
  {
    title: "АЯЛАНГАА АНГЛИ ХЭЛ",
    desc: "Аялангаа англи хэл сурах боломжийг бүрдүүлж, Cebu хотод чанартай сургалтанд хамрагдан хэлний мэдлэгээ богино хугацаанд үр дүнтэйгээр хөгжүүлэх нөхцөлийг бүрдүүлнэ.",
    className: "cyan",
    image: logo2,
  },
  {
    title: "AI IDEA ROOM",
    desc: "Хиймэл оюун ухаанаар Ochiroo’s Theory шинжилгээг хийж, зах зээлийн ирээдүйн дүн шинжилгээ таамгыг өгнө.",
    className: "green",
    image: logo3,
  },
];

const TrainingsSection = () => {
  const [hideBook, setHideBook] = useState(false);

  useEffect(() => {
    const footer = document.querySelector(".siteFooter") || document.querySelector("footer");

    if (!footer || typeof IntersectionObserver === "undefined") {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHideBook(entry.isIntersecting);
      },
      {
        threshold: 0.01,
      }
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section className="trainings-section">
      <div className="trainings-section__container">
        <h2 className="trainings-section__title">Сургалтууд</h2>

        <div className="trainings-section__layout">
          <div className="trainings-section__grid">
            {trainings.map((item, index) => (
              <div
                key={index}
                className={`training-card training-card--${item.className}`}
              >
                <div className="training-card__content">
                  <h3 className="training-card__title">{item.title}</h3>
                  <p className="training-card__desc">{item.desc}</p>

                  <Link to="/courses/advanced/list" className="training-card__button">
                    Дэлгэрэнгүй үзэх
                    <span className="training-card__arrow">→</span>
                  </Link>
                </div>

                <div className="training-card__image">
                  <img src={item.image} alt={item.title} />
                </div>

                <div className="training-card__overlay" />
              </div>
            ))}
          </div>

          <div className="trainings-section__side trainings-section__side--xl">
            <a
              className={`amazon-card ${hideBook ? "amazon-card--hidden" : ""}`}
              href="https://a.co/d/09P9AB3F"
              target="_blank"
              rel="noreferrer"
              aria-label="Buy Ochiroo's Theory book"
            >
              <img src={book} alt="book" className="amazon-card__image" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingsSection;
